<div class="warn-msg-box" *ngIf="storage_space_status || storage_subscription_status || package_subscription_status">
  <div class="item-warn" *ngIf="storage_space_status === 'warn'">
    <svg-icon 
      src="assets/svg/warning_white.svg" 
      [svgStyle]="{ 'width.px': 22, 'height.px': 22, 'margin-bottom.px': '2'}">
    </svg-icon>
    {{'DASHBOARD.STORAGE_SPACE_STATUS_WARN'|translate}}
  </div>
  <div class="item-critical" *ngIf="storage_space_status === 'critical'">
    <svg-icon 
      src="assets/svg/warning_white.svg" 
      [svgStyle]="{ 'width.px': 22, 'height.px': 22, 'margin-bottom.px': '2'}">
    </svg-icon>
    {{'DASHBOARD.STORAGE_SPACE_STATUS_CRITICAL'|translate}}
  </div>

  <div class="item-warn" *ngIf="storage_subscription_status === 'warn'">
    <svg-icon 
      src="assets/svg/carbon_calendar_white.svg" 
      [svgStyle]="{ 'width.px': 22, 'height.px': 22, 'margin-bottom.px': '2' }">
    </svg-icon>
    {{'DASHBOARD.STORAGE_SUBSCRIPTION_STATUS_WARN'|translate}}
  </div>
  <div class="item-critical" *ngIf="storage_subscription_status === 'critical'">
    <svg-icon 
      src="assets/svg/carbon_calendar_white.svg" 
      [svgStyle]="{ 'width.px': 22, 'height.px': 22, 'margin-bottom.px': '2' }">
    </svg-icon>
    {{'DASHBOARD.STORAGE_SUBSCRIPTION_STATUS_CRITICAL'|translate}}
  </div>

  <div class="item-warn" *ngIf="package_subscription_status === 'warn'">
    <svg-icon 
      src="assets/svg/time_warning_white.svg" 
      [svgStyle]="{ 'width.px': 22, 'height.px': 22, 'margin-bottom.px': '2' }">
    </svg-icon>
    {{'DASHBOARD.PACKAGE_SUBSCRIPTION_STATUS_WARN'|translate}}
  </div>
  <div class="item-critical" *ngIf="package_subscription_status === 'critical'">
    <svg-icon 
      src="assets/svg/time_warning_white.svg" 
      [svgStyle]="{ 'width.px': 22, 'height.px': 22, 'margin-bottom.px': '2' }">
    </svg-icon>
    {{'DASHBOARD.PACKAGE_SUBSCRIPTION_STATUS_CRITICAL'|translate}}
  </div>

  <div class="item-warn" *ngIf="additional_vm_subscription_status === 'warn'">
    <svg-icon 
      src="assets/svg/carbon_calendar_white.svg" 
      [svgStyle]="{ 'width.px': 22, 'height.px': 22, 'margin-bottom.px': '2' }">
    </svg-icon>
    {{'DASHBOARD.ADDITIONAL_VM_SUBSCRIPTION_STATUS_WARN'|translate}}
  </div>
  <div class="item-critical" *ngIf="additional_vm_subscription_status === 'critical'">
    <svg-icon 
      src="assets/svg/carbon_calendar_white.svg" 
      [svgStyle]="{ 'width.px': 22, 'height.px': 22, 'margin-bottom.px': '2' }">
    </svg-icon>
    {{'DASHBOARD.ADDITIONAL_VM_SUBSCRIPTION_STATUS_CRITICAL'|translate}}
  </div>
</div>

<div class="content" [class.pb-0]="!showDashboard">
  <div class="box row flex-column-reverse mx-0 flex-lg-row">
    <app-saved-dashboard *ngIf="showDashboard"
        class="p-0 flex-grow-1 d-md-flex col-lg-8 d-lg-block">
    </app-saved-dashboard>
    <div class="content-box col-lg-4"
        [ngClass]="{'no-dashboard': !showDashboard}">
      <div class="context d-flex flex-column">
        <app-lang-selector class="align-self-end mb-base-u12 lang"
            [ngClass]="{'lang': !(content === 'login' && deviceType === 'mobile')}"
            [style]="'dropdown'"
            [enableHover]="false"
        ></app-lang-selector>
        <img class="mb-base-u8 align-self-center"
            *ngIf="theme?.logo_rec"
            alt=""
            [src]="(theme.logo_rec | secure | async)"
            [style.max-height.px]="deviceType === 'desktop' ? 50: 40">

        <ng-container [ngSwitch]="content">
          <app-login *ngSwitchCase="'login'"
              (forgetPassword)="changeContent('forget-password')">
          </app-login>

          <app-forget-password *ngSwitchCase="'forget-password'"
              (login)="changeContent('login')">
          </app-forget-password>

          <app-set-password *ngSwitchCase="'reset-password'"
              class="content-overflow">
          </app-set-password>

          <app-reset-password *ngSwitchDefault
              class="content-overflow"
          ></app-reset-password>
        </ng-container>
      </div>
    </div>
  </div>
</div>
